export default __webpack_public_path__ + "static/media/w02.4c107c96.svg";